import { useNavCategoryApi } from './useNavCategoryApi';
import { useNavCategoryGetters } from './useNavCategoryGetters';
import { useNavCategoryHelper } from './useNavCategoryHelper';

import type { UseNavCategory } from './types';
export function useNavCategory(): UseNavCategory {
  return {
    ...useNavCategoryApi(),
    ...useNavCategoryGetters(),
    ...useNavCategoryHelper(),
  };
}
